export default __webpack_public_path__ + "static/media/touchTwo.c2f8eb22.svg";